import React from 'react';

import { useIntl } from 'react-intl';

import { ICartSectionHeading } from './types';

import SectionHeading from '.';

const CartSectionHeading: React.FC<ICartSectionHeading> = ({ isCatering }) => {
  const { formatMessage } = useIntl();
  return (
    <SectionHeading id="cart-section-heading-label">
      {isCatering ? formatMessage({ id: 'itemsInThisOrder' }) : formatMessage({ id: 'yourCart' })}
    </SectionHeading>
  );
};

export default CartSectionHeading;
